import { render, staticRenderFns } from "./VehicleTypes.vue?vue&type=template&id=72557822"
import script from "./VehicleTypes.vue?vue&type=script&lang=js"
export * from "./VehicleTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports